//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import TermsOfUseContent from '../../home/subComponents/subFaqComponents/TermsOfUseContent';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},

        aboutUsProfileContainer: {
            padding: 10,
            background: 'white',
            borderRadius: 10,
        },
        aboutUsContent: {
            padding: '0px 20px',
            // overflowY: 'scroll',
            // overflowX: 'hidden',
            // height: 530,
            // [theme.breakpoints.down('md')]: { height: '700px' },
            // '&::-webkit-scrollbar-track': {
            //     borderRadius: '10px',
            //     background: 'none',
            // },
            // '&::-webkit-scrollbar': {
            //     width: '8px',
            //     backgroundColor: '#F5F5F5',
            // },
            // '&::-webkit-scrollbar-thumb': {
            //     borderRadius: '10px',
            //     backgroundColor: 'rgba(0,0,0,0.2)',
            // },
        },
        paragraphText: { fontSize: 18, fontWeight: 400 },
        sidebarHeading: {
            fontWeight: 'bold',
            fontSize: 18,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 15,
            cursor: 'pointer',
            borderLeft: '4px solid rgba(255, 255, 255, 1)',
            '&:hover': { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' },
        },
        TitleText: { fontSize: 20, textAlign: 'center' },
        TitleTextAGREEMENT: { fontSize: 20 },
        headerText: { fontSize: 20, fontWeight: 'bold' },
        updateText: { fontStyle: 'italic', color: '#434343', fontSize: 18 },
        designatedText: { textDecoration: 'underline' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        root: {},
        salesLink: { href: 'mailto:eliu@afootinthedoor.work', target: '_blank' },
        infoLink: { href: 'mailto:eliu@afootinthedoor.work', target: '_blank' },
    };

    // inject classes
    setClassNameInDefns(defns, classes);
    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const TermsOfUse = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <TermsOfUseContent />
        </div>
    );
};

export default TermsOfUse;
